module.exports = ".login-page label {\r\n  font-weight: 600;\r\n  text-transform: none;\r\n}\r\n\r\n.divlogotop {\r\n  padding: 11.5% 0 2% 25px;\r\n}"